import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getEmbeddedSoftwarePath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/vyvoj/embedded-software",
		[Locale.en]: "/development/embedded-software",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
